// classes.ts
export default {
  tabsContainer: 'flex items-center relative',
  tabsContainerRef: 'flex overflow-x-auto no-scrollbar w-full',
  tab: 'flex flex-1 flex-col items-center justify-end cursor-pointer border-b-2  text-[12px] px-[15px] py-[9px] font-medium w-[150]',
  leftButton: 'left-0 z-10',
  rightButton: 'right-0 z-10',
};
